export default class Setting {
  constructor({ pincodes, managerNumbers, smsNumber }) {
    this.pincodes = pincodes;
    this.managerNumbers = managerNumbers;
    this.smsNumber = smsNumber;
  }
}
